<h1>{{ title }}</h1>
<span *ngIf="detail !== ''">{{ detail }}</span>
<ng-content></ng-content>
